import React, { Component } from "react";
// import Loader from '../../common/loader'
import loader from "../images/loader.gif";
export const PnkLoader = (props) => {
  return (
    <div id="pnkLoaderSmall"
      style={{
        /*boxShadow: '0 0 11px 2px',*/
        opacity: "0.9",
        padding: "0",
        borderRadius: "6px",
        position: "absolute",
        textAlign: "center",
        zIndex: "99999",
        left: "47%",
        top: "45%",
      }}
    >
      {props.size === "small" ? (
        // <Loader />
        <img
          height="80px"
          width="80px"
          src={loader}
          // src={require("../images/small1.gif")}
          style={{ opacity: 1 }}
          alt=""
        />
      ) : props.size === "large" ? (
        <img
          height="100"
          width="100"
          src={require("../images/small1.gif")}
          alt=""
        />
      ) : (
            <img
              height="100"
              width="100"
              src={require("../images/small1.gif")}
              alt=""
            />
          )}
    </div>
  );
};
